import React, { useEffect, useState } from 'react'
import PageHead from '../components/PageHead'
import Button from '../ui/comp/Button'
import { displayImage, exportButton } from '../utils/config'
import { CiExport } from 'react-icons/ci'
import Input from '../ui/forms/Input'
import { FiEdit, FiPlus } from 'react-icons/fi'
import Container from '../ui/comp/Container'
import Table from '../ui/Table/Table'
import Thead from '../ui/Table/Thead'
import Td from '../ui/Table/Td'
import { CgTrash } from 'react-icons/cg'
import ReactPaginate from 'react-paginate'
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa'
import NoContent from '../components/NoContent'
import Tbody from '../ui/Table/Tbody'
import { useStaffs } from '../hooks/useStaffs'
import Loading from '../components/Loading'
import Avatar from '../ui/comp/Avatar'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import userImage from '../assets/user.png'
import { Axios, baseURL } from '../utils/Axios'
import Select from '../ui/comp/Select'
import toast from 'react-hot-toast'
import axios from 'axios'

function Staffs() {

    const [formData, setFormData] = useState({ firstname: "", lastname: "", email: "", password: "", display_picture: "", role: "" });
    const [isOpen, setIsOpen] = useState(false)

    const [staffs, setStaffs] = useState([])
    const [searchText, setSearchText] = useState("");
    const queryClient = useQueryClient();

    const [page, setPage] = useState(1);
    const limit = 50
    const [totalPages, setTotalPages] = useState(0)

    const { data, isLoading, refetch } = useStaffs(page, limit, searchText);

    useEffect(() => {
        setTotalPages(data?.totalPages)
        setStaffs(data?.staffs || [])
    }, [data])



    // inputChane

    const inputChange = (e) => {
        const { id, value } = e.target;
        setFormData({ ...formData, [id]: value })
    }


    // uploading file

    const fileChangeBanner = async (files) => {
        if (files?.length) {
            const formData1 = new FormData();

            Object.keys(files).forEach(key => {
                formData1.append('file', files[key])
            })
            try {
                const res = await axios.post(`${baseURL}/upload`, formData1)
                const data = await res.data;
                setFormData({ ...formData, display_picture: data[0] })
                console.log(formData);
                toast.success('File Uploaded')
            } catch (error) {
                toast.error(error?.response?.data || "Error while uploading file")
            }
        }
    }

    // Delete
    const { mutate: deleteMutate } = useMutation({
        mutationFn: async (id) => {
            return Axios.delete('/staff?id=' + id)
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["staffs"] })
        }
        ,
        onError: (error) => {
            toast.error(error?.response?.data || error.message)
        },
    })

    const handleDelete = (id) => {
        if (window.confirm("Are you sure you want to delete")) {
            deleteMutate(id)
        }
    }

    // Send Data

    const { mutate, isPending } = useMutation({
        mutationFn: async (formData) => {
            return Axios.post('/staff', formData)
        },
        onError: (error) => {
            toast.error(error?.response?.data || error.message)
        },
        onSuccess: () => {
            setIsOpen(false)
            setFormData({ firstname: "", lastname: "", email: "", password: "", display_picture: "", role: "" })
            toast.success("Successfully")
            queryClient.invalidateQueries({ queryKey: ["staffs"] })
        }
    })

    const sendData = () => {
        mutate(formData)
    }


    if (isLoading) {
        return (
            <div>
                <Loading />
            </div>
        )
    }

    return (
        <div className='w-full relative'>
            {/* Head */}
            <PageHead title={"Staff Members"} />

            {/* Filter palce */}
            <div className="flex items-center justify-between w-full mt-8">
                <div className='max-w-48 w-full'>
                    <Button
                        onClick={() => exportButton("staffs")}
                        color={'primary'}
                        icon={<CiExport size={18} />}
                    >
                        Export
                    </Button>
                </div>

                <div className='flex items-center gap-3'>
                    <Input placeholder="Staff name" onChange={(e) => {
                        const value = e.target.value;
                        setSearchText(value)
                        setTimeout(() => {
                            refetch()
                        }, 500);

                    }} />
                    <Button onClick={() => setIsOpen(true)} icon={<FiPlus />} >Add Staff</Button>
                </div>
            </div>

            {/* Add and Update Operation */}
            {isOpen && (
                <div className="w-full relative mt-7">
                    <Container>
                        <div className="space-y-8">
                            {/* Row 1 */}
                            <div className="flex w-full items-center gap-5">
                                {/* Picture */}
                                <div className="w-full space-y-3">
                                    <p className="text-sm">Display Picture</p>
                                    <div>
                                        <input type='file' onChange={(e) => fileChangeBanner(e.target.files)} />
                                        <div className="mt-2">
                                            <img src={displayImage(formData?.display_picture)} alt="" className="w-24 p-1 border" />
                                        </div>
                                    </div>
                                </div>
                                {/* Firstname */}
                                <div className="w-full space-y-3">
                                    <p className="text-sm">Firstname</p>
                                    <div>
                                        <Input value={formData?.firstname} id="firstname" onChange={inputChange} />
                                    </div>
                                </div>

                                {/* Lastname */}
                                <div className="w-full space-y-3">
                                    <p className="text-sm">Lastname</p>
                                    <div>
                                        <Input value={formData?.lastname} id="lastname" onChange={inputChange} />
                                    </div>
                                </div>
                            </div>
                            {/* Row 2 */}
                            <div className="flex w-full items-center gap-5">
                                {/* Email */}
                                <div className="w-full space-y-3">
                                    <p className="text-sm">Email</p>
                                    <div>
                                        <Input value={formData?.email} id="email" onChange={inputChange} />
                                    </div>
                                </div>
                                {/* Role */}
                                <div className="w-full space-y-3">
                                    <p className="text-sm">Role</p>
                                    <div>
                                        <Select classic value={formData?.role} onChange={(e) => setFormData({ ...formData, role: e.target.value })}>
                                            <option value="" disabled>__</option>
                                            <option value="cashier">Cashier</option>
                                            <option value="admin">Admin</option>
                                            <option value="operator">Operator</option>
                                        </Select>
                                    </div>
                                </div>

                                {/* Password */}
                                <div className="w-full space-y-3">
                                    <p className="text-sm">Password</p>
                                    <div>
                                        <Input placeholder={formData?.password} id="password" onChange={inputChange} />
                                    </div>
                                </div>
                            </div>

                            <div className="flex gap-3">
                                <Button
                                    loading={isPending}
                                    onClick={sendData}
                                >{formData?.id ? "Update" : "Add Staff"}</Button>
                                <Button
                                    onClick={() => {
                                        setIsOpen(false)
                                        setFormData({ firstname: "", lastname: "", email: "", password: "", display_picture: "", role: "" })
                                    }}
                                    color="red"
                                >Cancel
                                </Button>
                            </div>
                        </div>
                    </Container>
                </div >

            )}
            {/*  Data*/}
            < div className="w-full relative mt-7" >
                {staffs && staffs?.length ? (
                    <Container>
                        <div className="w-full relative">
                            <Table>
                                <Thead>
                                    <tr>
                                        <Td>Joining Date</Td>
                                        <Td>Image</Td>
                                        <Td>Name</Td>
                                        <Td>Email</Td>
                                        <Td>Role</Td>
                                        <Td>Actions</Td>
                                    </tr>
                                </Thead>

                                <Tbody>
                                    {staffs?.map((staff, i) => (
                                        <tr key={i}>
                                            <Td>{new Date(staff?.iat).toLocaleString('en-GH', { dateStyle: 'medium' })}</Td>
                                            <Td>
                                                <Avatar rounded size={"md"}
                                                    src={staff?.display_picture !== "" ? displayImage(staff?.display_picture) : userImage}
                                                />
                                            </Td>
                                            <Td>{`${staff?.firstname} ${staff?.lastname}`}</Td>
                                            <Td>{`${staff?.email}`}</Td>
                                            <Td>{`${staff?.role}`}</Td>
                                            <Td>
                                                <div className="flex items-center gap-3 text-gray-500">
                                                    <button
                                                        onClick={() => {
                                                            setIsOpen(true)
                                                            setFormData(staff)
                                                        }}
                                                        className='text-primary' title='Edit'
                                                    >
                                                        <FiEdit size={18} />
                                                    </button>
                                                    <button onClick={() => handleDelete(staff?.id)} title='Delete' className='text-red-400'>
                                                        <CgTrash size={18} />
                                                    </button>
                                                </div>
                                            </Td>
                                        </tr>
                                    ))}
                                </Tbody>
                            </Table>
                        </div>


                        {/* Pagination */}
                        <div className="p-2 flex justify-end">
                            <ReactPaginate
                                nextLabel={<FaChevronRight />}
                                previousLabel={<FaChevronLeft />}
                                previousClassName='mr-2 text-primary/80'
                                nextClassName='ml-2 text-primary/80'
                                containerClassName='flex text-sm items-center gap-2'
                                activeClassName='bg-primary text-white'
                                pageClassName='size-8 rounded-lg bg-gray-100 flex items-center justify-center'
                                pageCount={totalPages}
                                onPageChange={({ selected }) => {
                                    setPage(selected + 1)
                                }}
                            />
                        </div>
                    </Container>
                ) : <NoContent />
                }
            </div >


        </div >
    )
}

export default Staffs